/**
 * Extracts the property name from a JSON path
 * @param path - JSON path like "content.pages.0.components" or "contentData.page.[*].components"
 * @returns The property name (last part of the path)
 * @example
 * getPropertyNameFromPath("content.pages.0.components") // returns "components"
 * getPropertyNameFromPath("contentData.page.[*].components") // returns "components"
 * getPropertyNameFromPath("simpleProperty") // returns "simpleProperty"
 */
export const getPropertyNameFromPath = (path?: string): string => {
  if (!path) {
    return '';
  }

  // Split the path by dots and get the last part
  const pathParts = path.split('.');

  // Filter out array indices (numbers) and wildcards
  const propertyParts = pathParts.filter((part) => {
    // Skip numeric indices and wildcards
    if (part === '[*]' || /^\d+$/.test(part)) {
      return false;
    }
    return true;
  });

  // Return the last property part, or the original path if no valid parts found
  return propertyParts.length > 0
    ? propertyParts[propertyParts.length - 1]
    : path;
};
